import { BannerKeys } from 'app/shared/model/banner-keys.enum';

import { FlowsiteTemplateReference } from './flowsite-template-reference.model';

export const FlowsiteBannerMetadataList: Readonly<
  Readonly<{
    regex: RegExp;
    reference: FlowsiteTemplateReference;
    bannerKey: BannerKeys;
  }>[]
> = [
  {
    regex: /timesheet/i,
    reference: FlowsiteTemplateReference.DashpivotXeroTimesheets,
    bannerKey: BannerKeys.FlowsiteXeroTimesheets,
  },
  {
    regex: /docket/i,
    reference: FlowsiteTemplateReference.DashpivotXeroDockets,
    bannerKey: BannerKeys.FlowsiteXeroDockets,
  },
  {
    regex: /power-bi-and-excel-for-analytics-tab/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcel,
    bannerKey: BannerKeys.FlowsitePowerBiExcel,
  },
  {
    regex: /site.*diary|diary.*site/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelSiteDiary,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /incident/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelIncidentReport,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /audit/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelAuditForm,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /swms|rams/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelSwmsRams,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /jsa/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelJsa,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /pre.*start/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelMachinePrestart,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /attendance/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelAttendanceRecord,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /non.*conformance|defect/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelNonConformanceDefectReport,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
  {
    regex: /cost|daywork/i,
    reference: FlowsiteTemplateReference.DashpivotPowerBiExcelCostDayworkReport,
    bannerKey: BannerKeys.FlowsitePowerBiExcelTemplates,
  },
];
